import React from 'react';
import MypageScheduleWaitingContainer from 'containers/MypageScheduleWaitingContainer/MypageScheduleWaitingContainer';

export default function MypageScheduleWaitingPage() {
    return (
        <MypageScheduleWaitingContainer />
    )
}
